import ManageMedia from '~/api/manage_media';

export default {
    getAccessSettingsStats({commit}, mediaId) {
        ManageMedia.getAccessSettingsStats(mediaId).then(response => {
            commit('updateStats', response);
        }).catch(() => {})
    }
}